import { render } from "./SplitViewLayout.vue?vue&type=template&id=b2407b2a&scoped=true"
import script from "./SplitViewLayout.vue?vue&type=script&lang=js"
export * from "./SplitViewLayout.vue?vue&type=script&lang=js"

import "./SplitViewLayout.vue?vue&type=style&index=0&id=b2407b2a&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2407b2a"]])

export default __exports__